// main initialization
// global libs
require(['jquery', 'bootstrap'], function($) {
    // website customization
    require([
        // 'tracking',
        './browser',
        './window',
        './modal',
        './menu',
        './menu-bar',
        './form', // necessary?
        './field', // necessary?
        './banner',
        './gallery',
        './events',
        './testimonials',
        './content-header',
        './cart',
        './awards',
        './questionnaire',
        './connect',
        './image-slider',
        './image-gallery',
        './audio-player',
        './animated-scroll-link',
        './block-with-banner',
    ], function(
        // Tracking,
        Browser,
        Wdw,
        Modal,
        Menu,
        MenuBar,
        Form,
        Field,
        Banner,
        Gallery,
        Events,
        Testimonials,
        ContentHeader,
        Cart,
        Awards,
        Questionnaire,
        Connect,
        ImageSlider,
        ImageGallery,
        AudioPlayer,
        AnimatedScrollLink
    ) {

        // -------------------
        //  GENERAL
        // -------------------

        // webkit stupidest hack ever (animation bug on pageload: https://lab.laukstein.com/bug/input)
        $('body').removeClass('preload');

        // ---------------- scroll start
        $('.scroll-start__heading').on('click.scroll', function(event) {
            var $section = $(this).closest('.section'),
                $next = $section.next();

            Wdw.scrollTo($next);
        });
    });
});